import { useCurrentSiteTakeover } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import type { TakeoverOptions } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import { SOCIETE_CHOOSE_DOUBLE_REWARDS_TAKEOVER_ID } from '../loyaltyChooseDoubleRewardsTakeover.constants'
import useLoyaltyChooseDoubleRewards from './useLoyaltyChooseDoubleRewards'

/**
 * All-in-one hook for consumers who need both campaign data and takeover eligibility.
 * Defer to {@link useLoyaltyChooseDoubleRewards} if caller already controls eligibility.
 */
function useLoyaltyActiveChooseDoubleRewards(options?: TakeoverOptions) {
  const takeover = useCurrentSiteTakeover(options)
  const rewards = useLoyaltyChooseDoubleRewards()
  if (takeover?.id !== SOCIETE_CHOOSE_DOUBLE_REWARDS_TAKEOVER_ID) {
    return undefined
  }

  return rewards
}

export default useLoyaltyActiveChooseDoubleRewards
